// Angular Files
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// Angular Material Files
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

// Module Files

// Teller Online Files
import { SharedModule } from 'apps/admin-portal/src/app/shared/shared.module';

// Teller Online Library Files
import { TellerOnlineHelpModule, HelpServiceBase } from 'teller-online-libraries/help';
import { ConfigHelpService } from 'apps/admin-portal/src/app/features/config/services/config-help.service';

// API Clients
import {
    AuthApiClient,
    AdminPaymentsApiClient,
    AdminScheduledPaymentsApiClient,
    AdminUsersApiClient,
    UserApiClient,
    ConfigurationApiClient,
    AuthorizationTextApiClient,
    LinkedAccountsApiClient
} from 'apps/admin-portal/src/app/core/api/AdminPortalApiClients';
import { HeaderComponent } from './components/header/header.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule, // Used by the NavMenuComponent
        SharedModule,
        TellerOnlineHelpModule,
        MatToolbarModule,
        MatIconModule,
        MatMenuModule,
        MatButtonModule,
        MatTooltipModule
    ],
    declarations: [HeaderComponent],
    exports: [HeaderComponent],
    providers: [
        AuthApiClient,
        AdminPaymentsApiClient,
        AdminScheduledPaymentsApiClient,
        AdminUsersApiClient,
        UserApiClient,
        ConfigurationApiClient,
        AuthorizationTextApiClient,
        LinkedAccountsApiClient,
        { provide: HelpServiceBase, useExisting: ConfigHelpService }
    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule?: CoreModule) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import it in the AppModule only');
        }
    }
 }
